import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Button';
import { connect } from 'react-redux';
import Items from './customItems';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Image from 'material-ui-image';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import IconButton from '@material-ui/core/IconButton';
import { Alert, AlertTitle } from '@material-ui/lab';
import axios from 'axios';
import TextField from '@material-ui/core/TextField';
import {
  logoutUser,
  uploadImage,
  editUserDetails,
} from '../../redux/actions/userActions';

const styles = {};
class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      latitude: '',
      longitude: '',
      entreeItems: [],
      sideItems: [],
      drinkItems: [],
      handle: '',
      address: 's',
      phone: 's',
      url: '',
      accountId: '',
      open: false,
      loading: false,
    };
  }

  componentWillReceiveProps(props) {
    const handle = props.credentials.handle;
    axios
      .get('/menu/' + handle + '/entrees')
      .then((res) => {
        this.setState({
          entreeItems: res.data,
        });
      })
      .catch((err) => console.error(err));

    axios
      .get('/menu/' + handle + '/sides')
      .then((res) => {
        this.setState({
          sideItems: res.data,
        });
      })
      .catch((err) => console.error(err));

    axios
      .get('/menu/' + handle + '/drinks')
      .then((res) => {
        this.setState({
          drinkItems: res.data,
        });
      })
      .catch((err) => console.error(err));
  }
  componentDidMount() {
    const urls = this.props.match.params.handle;

    const urlss = window.location.href;
    const p = new URL(urlss);
    const gcode = p.searchParams.get('code');

    if (gcode) {
      axios
        .get('/createAccount' + '?code=' + `${gcode}`)
        .then((res) => {
          this.setState({
            accountId: res.data,
          });
          this.saveStripeAccountToUser();
          //window.location.replace("/profile");
        })
        .catch((err) => console.error(err));
    }
  }

  saveStripeAccountToUser = () => {
    //save stripe account to user
    const userDetails = {
      phone: this.state.phone,
      address: this.state.address,
      handle: this.state.handle,

      accountId: this.state.accountId,
    };

    this.props.editUserDetails({ userDetails });
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
  };
  handleSubmit = () => {
    axios
      .get('/getLink')
      .then((res) => {
        this.setState({
          url: res.data.url,
        });

        window.location = this.state.url;
      })
      .catch((err) => console.error(err));
  };

  handleEditPicture = () => {
    const fileInput = document.getElementById('imageInput');
    fileInput.click();
  };

  handleImageChange = (event) => {
    const image = event.target.files[0];
    //send to server
    const formData = new FormData();
    formData.append('image', image, image.name);
    this.props.uploadImage(formData);
  };

  handleLocation = () => {
    if (this.state.phone && this.state.address) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          this.showPosition,
          this.showError
        );

        alert('Updated location successfully');
      }
    } else {
      alert(
        'You must provide a phone number and address before updating location!'
      );
    }
  };

  handleEditDetails = () => {
    this.setState({
      open: true,
      loading: false,
    });

    this.mapUserDetailsToState(this.props.credentials);
  };
  mapUserDetailsToState = (credentials) => {
    this.setState({
      address: credentials.address,
      phone: credentials.phone,
      handle: credentials.handle,
    });
  };

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleSubmitDetails = () => {
    const userDetails = {
      phone: this.state.phone,
      address: this.state.address,
      handle: this.state.handle,

      accountId: this.state.accountId,
    };

    this.props.editUserDetails({ userDetails });
    this.handleClose();
  };
  showPosition = (position) => {
    const addItemData = {
      latitude: position.coords.latitude,
      longitude: position.coords.longitude,
      phone: '2627297384',
      name: this.props.user.credentials.handle,
      address: '424 my address st',
    };

    axios
      .post('/location', addItemData)
      .then((res) => {})
      .catch((err) => console.error(err));
  };

  render() {
    const {
      user: {
        credentials: { handle, createdAt, imageUrl },
        loading,
        authenticated,
      },
    } = this.props;

    const curUser = this.props.user.credentials.handle;
    const phone = this.props.user.credentials.phone;
    const address = this.props.user.credentials.address;
    const image = this.props.user.credentials.imageUrl;
    const entreeItems = this.state.entreeItems;
    const sideItems = this.state.sideItems;
    const drinkItems = this.state.drinkItems;

    let profileMarkUp = !this.loading ? (
      authenticated ? (
        <div style={{ margin: '0 auto', maxWidth: 410 }}>
          <div style={{ backgroundColor: 'white' }}>
            <div style={{ backgroundColor: 'white' }}>
              <Image
                alt=""
                src={image}
                style={{
                  maxHeight: 410,
                }}
              />
            </div>

            <Divider />
            <input
              type="file"
              id="imageInput"
              onChange={this.handleImageChange}
              hidden="hidden"
            />
            <IconButton onClick={this.handleLocation} className="button">
              <Typography
                style={{
                  fontSize: 'medium',

                  color: 'rgb(29, 161, 242)',
                }}
                variant="h6"
              >
                Update Location
              </Typography>
            </IconButton>

            <IconButton onClick={this.handleEditPicture} className="button">
              <Typography
                style={{
                  fontSize: 'medium',

                  color: 'rgb(29, 161, 242)',
                }}
                variant="h6"
              >
                Upload Picture
              </Typography>
            </IconButton>
            <IconButton onClick={this.handleEditDetails} className="button">
              <Typography
                style={{
                  fontSize: 'medium',
                  color: 'rgb(29, 161, 242)',
                }}
                variant="h6"
              >
                Edit Details
              </Typography>
            </IconButton>
            <Dialog
              open={this.state.open}
              onClose={this.handleClose}
              fullWidth
              maxWidth="sm"
            >
              <DialogTitle>Edit User details</DialogTitle>
              <DialogContent>
                <form>
                  <TextField
                    name="phone"
                    type="text"
                    label="phone"
                    placeholder="contact number"
                    value={this.state.phone}
                    onChange={this.handleChange}
                    fullWidth
                  />

                  <TextField
                    name="address"
                    type="text"
                    label="address"
                    placeholder="adress information"
                    value={this.state.address}
                    onChange={this.handleChange}
                    fullWidth
                  />
                </form>
              </DialogContent>

              <DialogActions>
                <Button onClick={this.handleClose} color="primary">
                  Cancel
                </Button>
                <Button onClick={this.handleSubmitDetails} color="primary">
                  Save
                </Button>
              </DialogActions>
            </Dialog>

            <Divider />

            <Divider />

            <Items
              menu={entreeItems}
              sides={sideItems}
              drinks={drinkItems}
              user={curUser}
            />

            {/* <Button onClick={this.handleSubmit}>
           <a >
              <img style={{marginLeft:'10px', marginTop: "1vh" }} src={"/stripebutton.png"} />
            </a>
           </Button>
          
            <Button onClick={this.handleLocation}>
              <a>
              <img style={{marginLeft:'5px', marginTop: "1vh" }} src={"/newlocation.png"} />
            </a>
              </Button> */}

            {/* <Button
              className="updateBut"
              variant="contained"
              color="primary"
              style={{ marginLeft: "1vw", marginTop: "-25px", height: "33px" }}
              onClick={this.handleLocation}
            >
              <Typography style={{}}> Update Location </Typography>
            </Button> */}
          </div>
          <Alert style={{ marginTop: '4vh' }} severity="info">
            <AlertTitle>Info</AlertTitle>
            <strong>
              In order to accept payments you must connect your account with
              stripe.
            </strong>
          </Alert>
        </div>
      ) : (
        <Paper>
          <div>not authenticated. no profile found try loggin in again.</div>
          <Link to={{ pathname: `/login` }}>Login</Link>
        </Paper>
      )
    ) : (
      <p>loading..</p>
    );

    return <div>{profileMarkUp}</div>;
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  credentials: state.user.credentials,
});
const mapActionsToProps = { logoutUser, uploadImage, editUserDetails };
Profile.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  uploadImage: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  editUserDetails: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(withStyles(styles)(Profile));
